var React = require('react');

function PlusCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Zm0,31A15,15,0,1,1,32,17,15,15,0,0,1,17,32Z","key":1}),React.createElement("polygon",{"points":"25 16.4 17.6 16.4 17.6 9 16.4 9 16.4 16.4 9 16.4 9 17.6 16.4 17.6 16.4 25 17.6 25 17.6 17.6 25 17.6 25 16.4","key":2})]);
}

PlusCircle.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = PlusCircle;

PlusCircle.default = PlusCircle;
